var render = function (_h,_vm) {var _c=_vm._c;return _c('Icon',{class:['SetIcon', _vm.data.class, _vm.data.staticClass],attrs:{"name":_vm.props.icon}})}
var staticRenderFns = []

export { render, staticRenderFns }